import React, { useId } from 'react'
import { Button, CheckboxGroup, Checkbox } from '../Embeds/Button'
import { Modal, ModalHeader } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { GroupValidation } from '../../helpers/validate'
import { Error, required } from '../Embeds/Title'
import { Input } from '../Embeds/Input'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useGroups } from '../../hooks/cache'
import { notifier } from '../../helpers/notifier'
import { useCloseModal } from '../../hooks/utils'
import { CLASSES } from '../../config'
import PropTypes from 'prop-types'

const Group = ({ close, initialValues, type }) => {
  const { t } = useTranslation()
  const formId = useId()
  const { modify, add } = useGroups()
  const [show, closeModal] = useCloseModal(close)

  const { control, register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(GroupValidation),
    defaultValues: initialValues
  })

  const handleAddGroup = async values => {
    const status = await add({ ...values, classes: values.classes.map(Number) })
    notifier.addGroup(status)
    if (status) closeModal()
  }

  const handleModifyGroup = async values => {
    const status = await modify({ id: initialValues.id, ...values, classes: values.classes.map(Number) })
    notifier.modifyGroup(status)
    if (status) closeModal()
  }

  const _modify = type === 'modify'
  const onSubmit = v => _modify ? handleModifyGroup(v) : handleAddGroup(v)
  const title = _modify ? t('create-group') : t('modify-group')

  return (
    <Modal show={show} backdrop='static' onHide={closeModal} scrollable={true}>
      <ModalHeader style={{ backgroundColor: '#f5f5f5' }} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </ModalHeader>
      <Modal.Body>
        <form id={formId} onSubmit={handleSubmit(onSubmit)}>
          <Input id='name' title={required(t('group-name'))} {...register('name')} />
          {errors.name && <Error>{t(errors.name.message)}</Error>}
          <Input id='maxCount' title={required(t('group-maxcount'))} type='number' {...register('maxCount')} />
          {errors.maxCount && <Error>{t(errors.maxCount.message)}</Error>}
          <CheckboxGroup name='classes' control={control} title={t('extra-classes')} render={<>
            {CLASSES.map(c => <Checkbox key={c.value} value={c.value.toString()}>{c.label}</Checkbox>)}
          </>} />
          {errors.classes && <Error>{t(errors.classes.message)}</Error>}
        </form>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#f5f5f5' }}>
        <Button form={formId} className='active' type='submit'>{title}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Group

Group.propTypes = {
  close: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  initialValues: PropTypes.object
}
